import React, {useEffect, useState} from 'react';
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
import passwordValidator from 'password-validator';
import {Actions as CREATEACCOUNTACTIONS} from '../../store/actions/createAccountActions';
import {Actions as LOGINACTIONS} from '../../store/actions/authenticationActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';


// Create a schema
var schema = new passwordValidator();

// Add properties to it
schema
.is().min(8)                                    // Minimum length 8
.is().max(100)                                  // Maximum length 100
.has().uppercase()                              // Must have uppercase letters
.has().lowercase()                              // Must have lowercase letters
.has().digits(1)                                // Must have at least 1 digits
.has().not().spaces()                           // Should not have spaces
// .is().not().oneOf(['Passw0rd', 'Password123']); // Blacklist these values


function PayrollGuideForm({
  saving,
  saved,
  profile,
  saveLead,
  error,
}) {

  const [data, setData] = useState({
    noOfEmployees: "1-5",
    name: "",
    surname: "",
    phone: "",
    organisation: "",
    email: "",
  });

  useEffect(() => {
    // load initial data required for anywhere
    if (profile){
      setData({
        ...data,
        name: profile.givenName || profile.name,
        surname: profile.familyName || profile.surname,
        email: profile.email,
      })
    }
  },[profile]);


  const handleChange = (event) => {
    setData({
      ...data,
      [event.target.name]: event.target.value
    })
  }

  const submitForm = (e) => {
    e.preventDefault();
    console.log('dataToSubmit',data)
    saveLead({...data,list: 10})
  }

  return (

    <div className="bg-white max-w-md w-full mx-auto rounded-lg overflow-hidden">
      <div className="px-4 py-8 sm:px-10">

        <div className="mt-0">

          {error && 
            <div className="rounded-md bg-red-50 p-4 mb-6">
              <div className="flex">
                <div className="ml-3">
                  <h3 className="text-sm leading-5 font-medium text-red-800">
                    Error: {error}
                  </h3>
                </div>
              </div>
            </div>

          }

          {/*<h2 className="text-2xl leading-6 font-extrabold tracking-tight text-gray-800 mb-6">
                      Order your Payroll Guide
                    </h2>*/}

          <form onSubmit={submitForm} className="space-y-6">
            
            <div className="grid grid-cols-12 gap-2 sm:gap-8">
              <div className="col-span-6">
                <label htmlFor="name" className="sr-only">
                  Name
                </label>
                <div className="rounded-md shadow-sm">
                  <input value={data.name} onChange={handleChange} name="name" id="name" placeholder="Name" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                </div>
              </div>

              <div className="col-span-6">
                <label htmlFor="surname" className="sr-only">
                  Surname
                </label>
                <div className="rounded-md shadow-sm">
                  <input value={data.surname} onChange={handleChange} name="surname" id="surname" placeholder="Surname" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                </div>
              </div>
            </div>

            <div>
              <label htmlFor="organisation" className="sr-only">
                Organisation
              </label>
              <div className="rounded-md shadow-sm">
                <input value={data.organisation} onChange={handleChange} name="organisation" id="organisation" placeholder="Organisation" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
              </div>
            </div>

            <div>
              <label htmlFor="noOfEmployees" className="sr-only">
                No of Employees
              </label>
              <div className="rounded-md shadow-sm">
                <select onChange={handleChange} name="noOfEmployees" id="noOfEmployees" className="mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5">
                  <option value="1-5">1-5 Employees</option>
                  <option value="6-10">6-10 Employees</option>
                  <option value="11-20">11-20 Employees</option>
                  <option value="21-40">21-40 Employees</option>
                  <option value="41-80">41-80 Employees</option>
                  <option value="81-200">81-200 Employees</option>
                  <option value="200+">200+ Employees</option>
                </select>
              </div>
            </div>

            <div>
              <label htmlFor="email" className="sr-only">
                Email
              </label>
              <div className="rounded-md shadow-sm">
                <input value={data.email} onChange={handleChange} name="email" id="email" placeholder="Email" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
              </div>
            </div>


            
            <div>
              <span className="block w-full rounded-md shadow-sm text-center">

                {
                  saving &&
                    <svg className="text-orange-600 inline-block animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                }
                {!saving && 
                  <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out">
                    Send me a Payroll Guide
                  </button>
                }
              </span>
            </div>
          </form>
        </div>
      </div>
      <div className="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10">
        <p className="text-xs leading-5 text-gray-500">By signing up, you agree to our <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Terms</a>, <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Data Policy</a> and <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Cookies Policy</a>.</p>
      </div>
    </div>
    
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my

  const createAccount = state && state.createAccount
  const profile = state && state.my && state.my.profile  || localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData'))

  return {
    saving: createAccount.savingLead,
    saved: createAccount.savedLead,
    profile: profile
  }
}

const mapDispatchToProps = dispatch => ({
  saveLead: (data) => dispatch(CREATEACCOUNTACTIONS.saveLead(data,'Payroll Guide',6084234)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PayrollGuideForm) 
